var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEBooklet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.01,
    height: 36.772,
    viewBox: "0 0 28.01 36.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_56373",
    "data-name": "Group 56373",
    transform: "translate(-20 -343.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87649",
    "data-name": "Path 87649",
    d: "M332.077,16.776h6.91L331,8.789V15.7A1.078,1.078,0,0,0,332.077,16.776Z",
    transform: "translate(-291.608 335.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87650",
    "data-name": "Path 87650",
    d: "M64.232,36.772H85.778A3.235,3.235,0,0,0,89.01,33.54V10.773H81.469a3.235,3.235,0,0,1-3.232-3.232V0h-14A3.235,3.235,0,0,0,61,3.232V33.54A3.235,3.235,0,0,0,64.232,36.772ZM70.7,17.309H81.469a1.077,1.077,0,1,1,0,2.155H70.7a1.077,1.077,0,0,1,0-2.155Zm0,4.309H81.469a1.077,1.077,0,1,1,0,2.155H70.7a1.077,1.077,0,0,1,0-2.155Zm0,4.309H81.469a1.077,1.077,0,1,1,0,2.155H70.7a1.077,1.077,0,0,1,0-2.155Zm-4.309-8.618a1.077,1.077,0,1,1-1.077,1.077A1.077,1.077,0,0,1,66.386,17.309Zm0,4.309A1.077,1.077,0,1,1,65.309,22.7,1.077,1.077,0,0,1,66.386,21.618Zm0,4.309A1.077,1.077,0,1,1,65.309,27,1.077,1.077,0,0,1,66.386,25.927Z",
    transform: "translate(-41 343.452)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEBooklet);
export default __webpack_public_path__ + "static/media/eBooklet.f6d9be4be708f69598ef0bb7c5de2e46.svg";
export { ForwardRef as ReactComponent };